<template>
  <!-- Layout limpo, sem header/sidebar/menu web -->
  <div class="pdv-auth-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "PdvDesktopAuthLayout",
};
</script>

<style scoped>
.pdv-auth-layout {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
</style>
